import styled, { css } from "styled-components";
import { Row, CardBody, CardTitle } from "reactstrap";

export const customCard = {
  setWidth: width => css`
    width: ${width};
  `,
  setMargin: margin => css`
    margin: ${margin} !important;
  `,
  setOpacity: opacity => css`
    opacity: ${opacity};
  `,
  setPadding: padding => css`
    padding: ${padding} !important;
  `,
};

const colorStyles = {
  danger: {
    bg: "red",
  },
  success: {
    borderColor: "#28c76f",
    bg: "green",
  },
  info: {
    borderColor: "#7367f0",
  },
  default: {
    bg: "#6e6b7b",
  },
  queima: {
    borderColor: "#ea5455",
  },
  risco: {
    borderColor: "#ff9f43",
  },
  impacto: {
    borderColor: "#00cfe8",
  },
  ignorados: {
    borderColor: "#ffbe3d",
  },
};

export const ItemRow = styled(Row)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-heigth: 253px !important;
  padding: 5px 10px 5px 0px !important;
  height: 100%;
`;

export const CustomRow = styled(Row)`
  height: 100%;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const GraphicContainer = styled.div`
  display: flex;
  justify-content: left;
  flex-direction: column;
  margin: 0;
  padding: 0 !important;
`;
export const PercentageList = styled.ul`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  list-style: none;
  margin: 0 !important;
  padding: 0 !important;
`;

export const Item = styled.li``;
export const ItemEnd = styled.li`
  cursor: pointer;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 5px;
  background: #fff;
  padding: 0px 10px 0px 10px;
  border: 1px solid ${props => (props.active ? " #7367f0" : "none")};
  border-radius: 5px;
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%) !important;
`;
export const Text = styled.h5`
  font-size: 20px;
  font-weight: bold;
  margin: 0px !important;
  color: ${props => props.color};
`;
export const TextInline = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 10px;
`;

export const TextInlineTotal = styled.h3`
  font-size: 9px;
  margin: 0 !important;
  & > span {
    font-size: 9px;
  }
`;

export const Title = styled.span`
  color: #7367f0;
  margin: 0 0 3px 0;
`;

export const Label = styled.span``;

export const Filter = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  list-style: none;
  margin: 0 !important;
  padding: 2px !important;
`;

export const CardCustomTotals = styled(CardBody)`
  ${({ margin = "3px 3px 5px 3px", padding = "5px 6px 5px 5px", type }) => css`
    margin: ${margin};
    line-height: 10px;
    cursor: pointer;
    ${customCard.setPadding(padding)}
    border-top: 2px solid  ${colorStyles[type ? type : "info"]
      .borderColor} !important;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%) !important;
  `}
`;

export const CardCustomTitle = styled(CardTitle)`
  font-size: 11px !important;
  font-weight: bold;
  margin: 0 !important;
  padding: 0px;
`;
